import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-cream-100" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "flex flex-col sm:flex-row sm:items-end justify-between mb-5 sm:mb-8 gap-3 sm:gap-4" }
const _hoisted_4 = { class: "section-subtitle" }
const _hoisted_5 = { class: "flex items-center gap-2 overflow-x-auto scrollbar-hide mb-6 pb-1" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-4 lg:gap-6"
}
const _hoisted_8 = {
  key: 1,
  class: "text-center py-20 text-accent/40"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MenuCard = _resolveComponent("MenuCard")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-brand font-semibold text-sm uppercase tracking-widest mb-1" }, "Fresh & Ready", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "section-title mb-1" }, "Today's Menu", -1)),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.today) + " — New dishes every day, made from scratch ", 1)
        ]),
        _createVNode(_component_router_link, {
          to: "/menu",
          class: "btn-outline text-sm self-start sm:self-auto"
        }, {
          default: _withCtx(() => [
            _cache[3] || (_cache[3] = _createTextVNode(" View Full Menu ", -1)),
            _createVNode(_component_ArrowRightIcon, { class: "w-4 h-4" })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterTabs, (cat) => {
          return (_openBlock(), _createElementBlock("button", {
            key: cat,
            class: _normalizeClass(["flex-shrink-0 px-3 py-1 sm:px-4 sm:py-1.5 rounded-full text-xs sm:text-sm font-medium border transition-all duration-150", _ctx.activeFilter === cat
            ? 'bg-brand text-white border-brand'
            : 'bg-white text-accent border-cream-200 hover:border-brand hover:text-brand']),
            onClick: ($event: any) => (_ctx.activeFilter = cat)
          }, _toDisplayString(cat), 11, _hoisted_6))
        }), 128))
      ]),
      (_ctx.filteredItems.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (item) => {
              return (_openBlock(), _createBlock(_component_MenuCard, {
                key: item.id,
                item: item,
                onAddToCart: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('add-to-cart', $event)))
              }, null, 8, ["item"]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("p", { class: "text-4xl mb-3" }, "🍽️", -1),
            _createElementVNode("p", { class: "font-semibold text-lg" }, "No dishes in this category today", -1),
            _createElementVNode("p", { class: "text-sm mt-1" }, "Check back tomorrow or browse all dishes", -1)
          ]))]))
    ])
  ]))
}